var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20548 0.694881C4.20548 0.311109 3.90568 0 3.53586 0C3.16603 0 2.86623 0.311109 2.86623 0.694881V2.37781C1.53317 2.57339 0.480025 3.66754 0.301747 5.06322L0.224471 5.66818C0.21137 5.77075 0.198842 5.87337 0.186888 5.97605C0.155178 6.24841 0.361963 6.48556 0.626336 6.48556H15.3737C15.638 6.48556 15.8448 6.24841 15.8131 5.97605C15.8012 5.87337 15.7886 5.77075 15.7755 5.66818L15.6983 5.06321C15.52 3.66755 14.4669 2.57342 13.1338 2.37782V0.694881C13.1338 0.311109 12.834 0 12.4642 0C12.0944 0 11.7946 0.311109 11.7946 0.694881V2.23996C9.26987 2.00663 6.73018 2.00663 4.20548 2.23995V0.694881Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.986 8.31592C15.9782 8.06907 15.7816 7.87532 15.5436 7.87532H0.456356C0.218352 7.87532 0.0217808 8.06907 0.0139644 8.31592C-0.0390686 9.99073 0.0589662 11.669 0.307829 13.3286C0.496226 14.585 1.47982 15.55 2.6992 15.6748L3.76436 15.7838C6.58129 16.0721 9.41871 16.0721 12.2356 15.7838L13.3008 15.6748C14.5202 15.55 15.5038 14.585 15.6922 13.3286C15.941 11.669 16.0391 9.99073 15.986 8.31592Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5abddcfc0c5b53d8b99cb765ac6c4788.svg";
export { ForwardRef as ReactComponent };